'use client';

import React, { useContext, useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { CaretUpDown as CaretUpDownIcon } from '@phosphor-icons/react/dist/ssr/CaretUpDown';

import { usePopover } from '@/hooks/use-popover';

import { workspaces, ProjectsPopover } from './projects-popover';
import DataContext from '@/contexts/DataContext';

// export function WorkspacesSwitch() {
export function ProjectsSwitch() {
  const popover = usePopover();
  // const workspace = workspaces[0];
  // const [popoverProject, setPopoverProject] = useState({name: 'Select a project', avatar: '/assets/workspace-avatar-1.png'});
  const { currentProject, setCurrentProject } = useContext(DataContext);
 
  return (
    <React.Fragment>
      <Stack
        direction="row"
        onClick={popover.handleOpen}
        ref={popover.anchorRef}
        spacing={2}
        sx={{
          alignItems: 'center',
          border: '1px solid var(--Workspaces-border-color)',
          borderRadius: '12px',
          cursor: 'pointer',
          p: '4px 8px',
        }}
      >
        <Avatar src={currentProject?.avatar} variant="rounded" />
        <Box sx={{ flex: '1 1 auto' }}>
          <Typography color="var(--Workspaces-title-color)" variant="caption">
            Project
          </Typography>
          <Typography color="var(--Workspaces-name-color)" variant="subtitle2">
            {currentProject?.name}
          </Typography>
        </Box>
        <CaretUpDownIcon color="var(--Workspaces-expand-color)" fontSize="var(--icon-fontSize-sm)" />
      </Stack>
      {/* <DataContext.Provider value={{popoverProject, setCurrentProject}}> */}
        <ProjectsPopover
          anchorEl={popover.anchorRef.current}
          // onChange={popover.handleClose}
          onChange={popover.handleChange}
          onClose={popover.handleClose}
          open={popover.open}
        />
      {/* </DataContext.Provider> */}
    </React.Fragment>
  );
}
